import moment from "moment";

export const _moment = moment;

export const fieldUpdate = (key) => {
  return {
    get() {
      return this.control[key];
    },
    set(value) {
      this.$emit("update:field", { value, key });
    },
  };
};

export const formatDate = (date, format = "YYYY-MM-DD") => {
  if (!date) return;
  return moment(new Date(date)).format(format);
};

export const isValidDate = (date, format = "MM/DD/YYYY") => {
  if (!date) return;
  return moment(date, format)._isValid;
};

export const randomIntGenerator = (max, min) => {
  return Math.floor(Math.random() * max) + min;
};

export const calcAge = (date) => {
  if (!date) return;
  const birthdate = new Date(date);
  return moment().diff(birthdate, "years");
};

export const calcDiff = (start, format = "seconds") => {
  if (!start) return;
  return moment().diff(start, format);
};
